import axios from 'axios';
import {API_BASE_URL} from 'constants/app';
import {ClientMetadataRepository} from "domain/ports/ClientMetadataRepository";
import {ClientMetadataResponse} from "domain/types/clientMetadataTypes";

export class HttpClientMetadataRepository implements ClientMetadataRepository {
    async getData(campaignPublicId: string): Promise<ClientMetadataResponse> {
        try {
            const response = await axios.get<ClientMetadataResponse>(`${API_BASE_URL}/api/v1/campaigns/${campaignPublicId}/client-metadata`);
            return response.data;
        } catch (error: unknown) {
            console.error('Error al obtener los departamentos y ocupaciones del cliente:', error);
            throw error;
        }
    }
}
